// US state tile-grid map coordinates (row, col) — approximating US geography
// as a grid so we can render each state as a small square with revenue-based color.
// Format: STATE_ABBR: [row, col] where 0,0 is top-left (NW corner).
export const US_STATE_GRID = {
  //          col: 0    1     2     3     4     5     6     7     8     9    10
  // row 0:      "AK"                                                        "ME"
  AK: [0, 0],
  ME: [0, 10],
  // row 1:                                                        "VT" "NH"
  VT: [1, 9], NH: [1, 10],
  // row 2:  "WA"  "MT"  "ND"  "MN"        "WI"        "MI"  "NY"  "MA"
  WA: [2, 1], MT: [2, 2], ND: [2, 3], MN: [2, 4],
  WI: [2, 5], MI: [2, 7], NY: [2, 8], MA: [2, 9], RI: [2, 10],
  // row 3:  "OR"  "ID"  "WY"  "SD"  "IA"  "IL"  "IN"  "OH"  "PA"  "NJ" "CT"
  OR: [3, 1], ID: [3, 2], WY: [3, 3], SD: [3, 4], IA: [3, 5],
  IL: [3, 6], IN: [3, 7], OH: [3, 8], PA: [3, 9], NJ: [3, 10],
  // row 4:  "CA"  "NV"  "UT"  "CO"  "NE"  "MO"  "KY"  "WV"  "VA"  "MD" "DE"
  CA: [4, 1], NV: [4, 2], UT: [4, 3], CO: [4, 4], NE: [4, 5],
  MO: [4, 6], KY: [4, 7], WV: [4, 8], VA: [4, 9], MD: [4, 10], DE: [4, 11],
  // row 5:              "AZ"  "NM"  "KS"  "AR"  "TN"  "NC"  "SC"       "DC"
  AZ: [5, 2], NM: [5, 3], KS: [5, 4], AR: [5, 5],
  TN: [5, 6], NC: [5, 7], SC: [5, 8], DC: [5, 10],
  // row 6:  "HI"        "TX"  "OK"  "LA"  "MS"  "AL"  "GA"
  HI: [6, 0], TX: [6, 3], OK: [6, 4], LA: [6, 5], MS: [6, 6],
  AL: [6, 7], GA: [6, 8],
  // row 7:                                                        "FL"
  FL: [7, 8],
};

export const US_STATE_NAMES = {
  AL:"Alabama",AK:"Alaska",AZ:"Arizona",AR:"Arkansas",CA:"California",CO:"Colorado",
  CT:"Connecticut",DE:"Delaware",DC:"D.C.",FL:"Florida",GA:"Georgia",HI:"Hawaii",
  ID:"Idaho",IL:"Illinois",IN:"Indiana",IA:"Iowa",KS:"Kansas",KY:"Kentucky",
  LA:"Louisiana",ME:"Maine",MD:"Maryland",MA:"Massachusetts",MI:"Michigan",MN:"Minnesota",
  MS:"Mississippi",MO:"Missouri",MT:"Montana",NE:"Nebraska",NV:"Nevada",NH:"New Hampshire",
  NJ:"New Jersey",NM:"New Mexico",NY:"New York",NC:"North Carolina",ND:"North Dakota",
  OH:"Ohio",OK:"Oklahoma",OR:"Oregon",PA:"Pennsylvania",RI:"Rhode Island",SC:"South Carolina",
  SD:"South Dakota",TN:"Tennessee",TX:"Texas",UT:"Utah",VT:"Vermont",VA:"Virginia",
  WA:"Washington",WV:"West Virginia",WI:"Wisconsin",WY:"Wyoming",
};
